export default __webpack_public_path__ + "8fab1b6952607afc0dedbe84c112b3e5.png";